<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        App Messages &nbsp; &nbsp;
       <span class="text-red text-bold">WARNING: Engineers Only!</span>
      </h1> 
      <div class="modal-backdrop" v-if="showNewFeaturePrompt">
        <div class="modal new-feature" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" style="height: 415px; width: 518px;">
          <header class="modal-header">
            <div class="header-style">
              <h3>New Features !</h3>
              <i v-on:click="closeNewFeatureModal" class="fa fa-close" style="font-size:22px;color:red" title="Close"></i>
            </div>
          </header>
          <section class="modal-body">
            <div class="style-section">
              <h4 class="style-button-section"><b>Button</b></h4>
              <div>We can now add buttons for message instead of asking the user to type the numbers.</div>
              <div class="style-template-text"><b>Template to use button:- </b></div>
              <div class="style-select-options">Please select one of the following options :- </div> 
              <span>{{ showTextInfoForButton }}</span>
              <h4 class="style-list-section"><b>List</b></h4>
              <div>We can support lists instead of buttons whenever the user has more than 3 options to be selected.</div>
              <div class="style-template-text"><b>Template to use list:- </b></div>
              <div class="style-select-options">Please select one of the following options :- </div> 
              <span>{{ showTextInfoForList }}</span>
            </div>
          </section>
        </div>
      </div>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>App Messages</li>
        <li class="active">Messages</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default">
            <div class="box-header with-border">
              <h3 class="box-title">App Messages List</h3>
                <div class="action-button pull-right">
                  <div class="style-new-icon">
                    <i class="fa fa-gift" v-on:click="showInfoPopUp" style="font-size:27px;" aria-hidden="true" title="New Features!"></i>
                </div>
                 <button  class="btn btn-primary"   type="button" @click="OpenPOP()">Add App</button>
                </div>
            <!-- </div>   -->
              <div class="modal-backdrop" v-if="showModal" id="Modal">
                <div class="modal modal-md" style="height: 200PX;max-width:500px">
                  <header class="modal-header">
                    <slot name="header">
                      <h3>{{ oprationname }}</h3>
                    </slot>
                    <div class="modal-body">
                      <slot name="body">
                      <form class="form-horizontal" @submit.prevent="addOrUpdate" action="#" method="post">
                        <div class="form-group hidden">
                          <label for="campaignType" style="font-weight:500" class="col-sm-4 control-label">App Type</label>
                          <div class="col-sm-8 text-left">
                           <label class="radio-inline">
                            <input  type="radio" name="campaignType" value="keyword" v-model="gRowObj.campaignType"/>Keyword
                          </label>
                          <label class="radio-inline">
                           <input type="radio" name="campaignType" value="generic" v-model="gRowObj.campaignType">Non Keyword
                          </label>
                          </div>
                          </div>
                        <div class="form-group">
                          <label for="campaign" style="font-weight:500" class="col-sm-4 control-label">App Name</label>
                          <div class="col-sm-8">
                             <input type="text" class="form-control" autocomplete="off" id="campaign" placeholder="App Name" v-model="gRowObj.campaign" v-bind:class="{'form-group--error': (submitted && !$v.gRowObj.campaign.required) || (submitted && !$v.gRowObj.campaign.campaignRegex) || keywordExistError }" />
                             <span v-if="submitted && !$v.gRowObj.campaign.required" class="text-red pull-ight" style="font-size:initial">Please enter App Name</span>
                             <span v-if="submitted && keywordExistError" class="text-red pull-right" style="font-size:initial">App Name already exists.</span>
                             <span v-if="submitted && !$v.gRowObj.campaign.campaignRegex" class="text-red pull-right" style="font-size:initial">Invalid Format.</span>
                          </div>
                        </div>
                        <div class="form-group pull-right">
                          <div class="col-sm-12">
                            <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                            <input type="submit" class="btn btn-primary" value="Submit">
                          </div>
                        </div>
                      </form>
                      </slot>
                    </div>
                  </header>
                  <footer class="modal-footer"></footer>
                </div>
              </div>
              <div class="box-body">
                <table class="table table-striped table-apps">
                  <thead>
                    <th>App Name</th>                  
                    <th class="th_center">Edit</th>
                    <th class="th_center">Download</th>
                  </thead>
                  <tbody v-show="appMessageData.length > 0">
                    <tr v-for="(appData, index) in appMessageData" :key="index">
                      <td>{{appData.campaign}}</td>                 
                      <td width="5%" class="td_center">
                        <router-link :to="`appmessageupdate?sheetTitle=${appData.campaign}&sheetReference=messagesForApps&id=${appData.id}`">
                          <i class="fa fa-pencil" aria-hidden="true"></i>
                        </router-link>
                      </td>
                      <td width="5%" class="td_center">
                        <button class="btn btn-primary" v-on:click="downloadCsvData(appData)">CSV</button>
                      </td>
                      <td width="50%">
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-show="appMessageData.length === 0">
                    <tr><td colspan="3" align="center">No result found.</td></tr>
                  </tbody>
                </table>
                
              </div>
            </div>
          </div>  
        </div> 
      </div>
    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
  </div> 
</template>
<script>
import api from '../../../utils/api'
import _ from 'lodash'
import {required, helpers} from 'vuelidate/lib/validators'
import { downloadCSV } from '../../../utils/utilities'
import { languages } from '../../../config/constants'

const campaignRegex = helpers.regex('alpha', /^[a-zA-Z0-9_]*$/)
export default {
  name: 'MessagesDashboard',
  validations: {
    gRowObj: {
      campaign: {
        required,
        campaignRegex
      }
    }
  },
  mounted () {
    this.getInfoAndWorksheets()
  },
  data () {
    return {
      showTextInfoForButton: '{{item1}} {{item2}} {{item3}}',
      showTextInfoForList: '{{item1}} {{item2}} {{item3}} {{item4}} [[ListButtonText]]',
      showNewFeaturePrompt: false,
      oprationname: '',
      storeData: {},
      rowIndexToBeUpdated: 0,
      showModal: false,
      keywordExistError: false,
      submitted: false,
      loading: true,
      keywordData: [],
      deployedApps: [],
      message: '',
      id: '',
      appMessageData: [],
      primaryLanguageData: {},
      secondaryLanguageData: {},
      gRowObj: {
        id: '',
        campaign: '',
        campaignType: '',
        config: {}
      },
      resetObj: {
        id: '',
        campaign: '',
        campaignType: '',
        config: {}
      },
      domain: {
        'localhost': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'hi',
          primaryLangText: 'English',
          secondaryLangText: 'Hindi'
        },
        'dashboard.mynivi.in': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'hi',
          primaryLangText: 'English',
          secondaryLangText: 'Hindi'
        },
        'india-dashboard-staging.herokuapp.com': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'hi',
          primaryLangText: 'English',
          secondaryLangText: 'Hindi'
        },
        'eu-dashboard-staging.herokuapp.com': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'swa',
          primaryLangText: 'English',
          secondaryLangText: 'Swahili'
        },
        'dashboard.mynivi.ke': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'swa',
          primaryLangText: 'English',
          secondaryLangText: 'Swahili'
        }
      }
    }
  },
  methods: {
    /**
     * @function OpenPOP
     * @description Function to open Add / Update Campaign
     * @param campaign Title / Name of the Campaign
     * @param id Document Id of the Campaign
     */
    OpenPOP (appData, index) {
      this.keywordExistError = false
      this.showModal = true
      // this.gRowObj.campaign = appData.campaign
      // this.gRowObj._id = appData._id
      console.log('open pop up id', this.gRowObj.id)
      console.log('this.gRowObj', appData)
      if (appData) {
        console.log('appdata', appData)
        this.gRowObj = _.clone(appData, true)
        this.storeData = appData
        this.rowIndexToBeUpdated = index
        // this.gRowObj._id = appData._id
        if (appData.campaign) {
          var searchPattern = new RegExp('^APP_LAUNCH')
          if (searchPattern.test(appData.campaign)) {
            console.log('find keywords', appData.campaign)
            this.gRowObj.campaignType = 'keyword'
          } else {
            this.gRowObj.campaignType = 'generic'
          }
        } else {
          this.gRowObj.campaignType = 'keyword'
        }
        // this.gRowObj.campaign = appData.campaign
        this.oprationname = 'Edit App'
      } else {
        this.gRowObj.campaignType = 'generic'
        this.oprationname = 'Add App'
      }
    },
    showInfoPopUp () {
      this.showNewFeaturePrompt = true
    },
    closeNewFeatureModal () {
      this.showNewFeaturePrompt = false
    },
    close () {
      this.showModal = false
      this.keywordExistError = false
      this.submitted = false
      // this.gRowObj.campaign = ''
      this.gRowObj = Object.assign({}, this.resetGRowObj())
    },
    resetGRowObj () {
      console.log('inside resetGRowObj method')
      return this.resetObj
    },
    getInfoAndWorksheets () {
      this.loading = true
      let skip = 0
      let selector = {}
      selector.isdeleted = false
      if (this.currentPage > 1) {
        skip = (this.currentPage - 1) * this.pageSize
      }
      let queryParams = {
        sheetReference: 'messagesForApps',
        selector: selector,
        skip: skip,
        limit: this.pageSize,
        sort: {
          createdAt: -1
        }
      }
      api.buildRequest('getDataFromMongo', 'POST', queryParams)
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              if (response.data.payload.keywords.length > 0) {
                console.log('data using to mongo db')
                this.keywordData = response.data.payload.keywords
                this.appMessageData = this.keywordData
                console.log(response.data.payload.keywords)
              } else {
                console.log('data using to goolesheet')
                this.keywordData = []
                this.appMessageData = this.keywordData
                // disable migration for now
                // this.getDataFromGoogleSheetByTitle(queryParams.sheetReference)
              }
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    getDataFromGoogleSheetByTitle (sheetTitle, sheetReference) {
      console.log('inside getDataFromGoogleSheetByTitle function')
      this.loading = true
      // this.config['stages'] = this.stages
      api.buildRequest('getAppMessagesFromGoogleSheetByTitle', 'POST', {sheetReference: 'messagesForApps'})
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.allRows = response.data.payload.data
              this.appMessageData = this.allRows
              // this.saveSheetName()
              console.log('Given Data', response.data.payload.data)
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    addOrUpdate (e) {
      console.log(`event data=${JSON.stringify(e)}`)
      this.showModal = true
      console.log('inside addOrUpdate function')
      // console.log(this.actionToBePerformed)
      // console.log(this.gRowObj)
      this.submitted = true
      this.keywordExistError = false
      var domainname = window.location.hostname
      this.primaryLanguageData = [this.domain[domainname].primaryLanguage]
      this.secondaryLanguageData = [this.domain[domainname].secondaryLanguage]
      console.log([this.domain[domainname].primaryLanguage])
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      let queryParams = {
        selector: {
          campaign: this.gRowObj.campaign,
          campaignType: this.gRowObj.campaignType,
          isdeleted: false
        }
      }
      console.log(this.gRowObj.campaignType)
      // this.loading = true
      if (this.gRowObj.campaignType === 'keyword') {
        console.log('call keyword')
        var searchPattern = new RegExp('^APP_LAUNCH')
        if (searchPattern.test(this.gRowObj.campaign)) {
          console.log('test keywords', this.gRowObj.campaign)
          queryParams.selector.campaign = queryParams.selector.campaign.toUpperCase()
          queryParams.selector.id = this.gRowObj.id
        } else {
          console.log('test keywords not app', this.gRowObj.campaign)
          queryParams.selector.campaign = 'APP_LAUNCH_' + queryParams.selector.campaign.toUpperCase()
          queryParams.selector.id = this.gRowObj.id
        }
        this.gRowObj.campaign = queryParams.selector.campaign
        console.log('campaign name', queryParams.selector.campaign)
      } else {
        console.log('after campaign', this.gRowObj.campaign)
        queryParams.selector.campaign = queryParams.selector.campaign.replace('APP_LAUNCH_', '')
        this.gRowObj.campaign = queryParams.selector.campaign = queryParams.selector.campaign.toUpperCase()
        // queryParams.selector.campaign = this.gRowObj.campaign.toUpperCase()
        queryParams.selector.id = this.gRowObj.id
        console.log('string', this.gRowObj.campaign)
      }
      // if (this.$route.query.keywordId && !this.$route.query.action) {
      //   queryParams.selector._id = { $ne: this.$route.query.keywordId }
      // }
        // const isKeywordExist = this.checkKeywordExists(queryParams)
        // NOW CHECK IF THAT KEYWORD ALREADY EXISTS
      console.log('check exit param', queryParams)
      api.buildRequest('checkIfCampaignExists', 'POST', queryParams)
      .then(response => {
        console.log(response.data.payload)
          // console.log(response.data.payload.facilities)
        if (response.status === 200) {
          let apiToCall = 'addAppmsg'
          console.log(response.data.payload)
          console.log('addmsg')
          // if (this.gRowObj._id) {
          //   apiToCall = 'updateAppmsg'
          //   console.log('config data', newRowObj)
          // }
          this.loading = false
          let trimmedObj = {}
          trimmedObj = this.trimJsonObj(this.gRowObj)
          console.log('trim object', trimmedObj)
          let newRowObj = {
            id: trimmedObj.id,
            campaign: trimmedObj.campaign,
            config: trimmedObj.config,
            campaignType: trimmedObj.campaignType,
            data: trimmedObj
          }
          console.log('data from saving', newRowObj)
          let params = {}
          params.newRow = Object.assign({}, newRowObj)
          console.log(this.gRowObj.id)
          if (response.data.payload === null || (this.storeData && this.storeData.campaign === this.gRowObj.campaign)) {
            if (this.gRowObj.id) {
              apiToCall = 'updateAppmsg'
              console.log('config data', newRowObj)
              this.appMessageData.splice(this.rowIndexToBeUpdated, 1, newRowObj)
              console.log('splice data', this.appMessageData)
            } else {
              delete params.updatedRow
              params.newRow = Object.assign({}, newRowObj)
              console.log('another data', params)
            }
            this.showModal = false
            this.performKeywordOperation(params, apiToCall, 'Campaign updated successfully.')
          } else {
            this.keywordExistError = true
          }
        }
      }).catch(({ response }) => {
        this.loading = false
        this.$swal({
          type: 'error',
          text: response ? response.data.payload.message : 'An error occurred'
        })
      })
    },
    performKeywordOperation (params, apiToCall, message) {
      this.loading = true
      console.log(`params=${JSON.stringify(params)}`)
      console.log('api', apiToCall)
      api.buildRequest(apiToCall, 'POST', params)
        .then(response => {
          if (response.status === 200) {
            console.log('response', response)
            this.close()
            console.log('after', this.gRowObj)
            if (apiToCall === 'addAppmsg') {
              this.gRowObj = response.data.payload.Data
              this.appMessageData.unshift(this.gRowObj)
              console.log('appmessagedata', this.appMessageData)
            }
            console.log('before', this.gRowObj)
            this.loading = false
            this.gRowObj = Object.assign({}, this.resetGRowObj())
            this.$swal({
              type: 'success',
              text: response ? response.data.payload.message : message
            })
          } else {
            console.log('something went wrong')
          }
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
    },
    trimJsonObj (obj) {
      const trimmedObj = {}
      Object.keys(obj).forEach(function (key) {
        console.log(key, obj[key])
        trimmedObj[key] = obj[key]
        if (obj[key] !== undefined && typeof obj[key] === 'string') {
          trimmedObj[key] = obj[key].trim()
        }
      })
      return trimmedObj
    },
    downloadCsvData (appData) {
      downloadCSV(this.formatDataForCsv(appData), appData['title'])
    },
    formatDataForCsv (appData) {
      const fields = ['App', 'Message', 'Country', 'Language', 'Translation']
      let updatedData = []
      const langs = languages.map(ele => ele['value'])

      if (appData.config) {
        const firstKey = Object.keys(appData.config)[0]
        const isKeyLanguage = langs.includes(firstKey) || (firstKey === 'Name')
        if (isKeyLanguage) {
          // Parse languages in message
          // Loop for every language in message
          Object.keys(appData.config).forEach(lang => {
            // Remove keys like 'Name' as it is not present in every message
            if (langs.includes(lang)) {
              // Loop through message names for every language
              Object.keys(appData.config[lang]).forEach(msg => {
                let msgData = appData.config[lang][msg]
                if (msgData.length === 0) msgData = `${''}`
                updatedData.push({'App': appData['title'], 'Country': '-', 'Message': msg, 'Language': lang, 'Translation': msgData})
              })
            }
          })
          // Changing the ordering so that all messages are together in csv and not by language
          var messagesGrouped = _.groupBy(updatedData, 'Message')

          // Clearing updatedData
          updatedData = []

          // Append values of grouped messages
          Object.keys(messagesGrouped).forEach(msg => {
            updatedData.push(...(messagesGrouped[msg]))
          })
        } else {
          // Loop for every message in app
          Object.keys(appData.config).forEach(message => {
            let messageData = []

            // Parse country -> language in message
            // Loop for every country in message
            Object.keys(appData.config[message]).forEach(country => {
              let countryData = []

              // Loop for every language in country
              Object.keys(appData.config[message][country]).forEach(language => {
                let langData = appData.config[message][country][language]
                if (langData.length === 0) langData = `${''}`
                countryData.push({'Language': language, 'Translation': langData})
              })

              if (countryData.length > 0) {
                console.log('country::', country, ' data::', countryData)
                countryData.forEach(data => {
                  messageData.push({'Country': country, ...data})
                })
              } else {
                messageData.push([country])
              }
            })

            if (messageData.length > 0) {
              // To add all the messages of the app
              messageData.forEach(data => {
                updatedData.push({'App': appData['title'], 'Message': message, ...data})
              })
            } else {
              // Exected When there is no message associated with app
              updatedData.push({'App': appData['title'], 'Message': message})
            }
          })
        }
      } else {
        updatedData.push({'App': appData['title']})
      }

      return {fields: fields, data: updatedData}
    }
  }
}
</script>
<style scoped>
  th {
    padding: 8px !important;
  }
  .th_center {
    text-align: center;
  }
  .td_center {
    text-align: center;
  }
.header-style {
  display: flex;
  justify-content: center;
  align-items: center;
}
.style-button-section{
  margin-top: -26px;
}
.style-list-section {
  margin-top: 20px;
}
.style-select-options {
  margin-top: 10px;
}
.style-template-text {
  margin-top: 15px;
}
.style-new-icon {
  margin-left: 15px;
  margin-right: 16px;
}
.modal-body {
  position: relative;
  min-height: 315px;    
}
</style>


// WEBPACK FOOTER //
// messageSheet.vue?7b215286